import React from 'react';
import { Button } from '../../ui/input/Button';
import { Box } from '../../ui/layout/Box';
import { Flex } from '../../ui/layout/Flex';
import { Image } from '../../ui/media/Image';
import { Typography } from '../../ui/typography/Typography';
import { buildPublicUrl } from '../../utils/buildUrl';
import { useTranslation } from '../../utils/useTranslation';

export function Login() {
    const t = useTranslation();

    return (
        <Flex width="100%" height="100%" backgroundColor="var(--background-primary)">
            <Flex
                px={3}
                pt={2.5}
                spacing={2}
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                width="100%"
            >
                <Typography color="link" variant="body" weight="bold">
                    {t('Я — автор')}
                </Typography>
                <Typography color="secondary" variant="body" weight="bold">
                    {t('Пропустить')}
                </Typography>
            </Flex>
            <Flex justifyContent="center">
                <Box pt={4} px={3}>
                    <Typography variant="title1" weight="bold">
                        {t('Лента\n вдохновения\n Яндекса')}
                    </Typography>
                </Box>
                <Box pt={2.5} px={3}>
                    <Typography variant="body" weight="bold" color="secondary">
                        {t('Откройте для себя мир интернета')}
                    </Typography>
                </Box>
                <Image src={buildPublicUrl('/images/onboarding.png')} />
                <Flex width="100%" alignItems="center">
                    <Button as="a" size="l">
                        <Typography variant="title3" weight="bold" color="inherit">
                            {t('Войти')}
                        </Typography>
                    </Button>
                </Flex>
            </Flex>
        </Flex>
    );
}
